import { render, staticRenderFns } from "./OrderFabric.vue?vue&type=template&id=d6c9b242&scoped=true&"
import script from "./OrderFabric.vue?vue&type=script&lang=js&"
export * from "./OrderFabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c9b242",
  null
  
)

export default component.exports